(function () {
  'use strict';

  /**
   * Mobile Sticky ATC — 3-Step Flow
   *
   * Step 1 → bar shows "SELECT SIZE" button
   * Step 2 → click → size panel expands above bar (backdrop dims page)
   * Step 3 → select a size → panel collapses, bar shows "ADD TO CART"
   *          click ATC → direct AJAX add, cart drawer always opens
   */

  function initMobAtcBar(bar) {
    var formId  = bar.dataset.formId;
    var form    = document.getElementById(formId);
    if (!form) return;

    // Native variant-picker is hidden on mobile via CSS but still in DOM
    var variantPicker = document.querySelector(
      'variant-picker[form-id="' + CSS.escape(formId) + '"]'
    );

    var backdrop  = document.querySelector('.mob-atc-bar__backdrop');
    var selectBtn = bar.querySelector('.mob-atc-bar__select-btn');
    var sizeGrid  = bar.querySelector('.mob-atc-bar__size-buttons');
    var atcBtn    = bar.querySelector('.mob-atc-bar__atc-btn');

    var selectedSizeBtn = null;
    var populated = false;

    /* ── Step 1 → 2: open panel ───────────────────────────── */
    if (selectBtn) {
      selectBtn.addEventListener('click', function () {
        if (!populated) {
          populateSizeButtons();
          populated = true;
        }
        openPanel();
      });
    }

    /* ── Backdrop click → close panel ─────────────────────── */
    if (backdrop) {
      backdrop.addEventListener('click', closePanel);
    }

    /* ── Step 3: Add to cart ──────────────────────────────── */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        submitForm();
      });
    }

    /* ── Panel helpers ────────────────────────────────────── */
    function openPanel() {
      bar.classList.add('is-open');
      if (backdrop) {
        backdrop.removeAttribute('hidden');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            backdrop.classList.add('is-visible');
          });
        });
      }
    }

    function closePanel() {
      bar.classList.remove('is-open');
      if (backdrop) {
        backdrop.classList.remove('is-visible');
        var onEnd = function () {
          if (!backdrop.classList.contains('is-visible')) {
            backdrop.setAttribute('hidden', '');
          }
          backdrop.removeEventListener('transitionend', onEnd);
        };
        backdrop.addEventListener('transitionend', onEnd);
      }
    }

    function submitForm() {
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;

      var orig = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      var formData = new FormData();
      formData.append('id', idInput.value);
      formData.append('quantity', '1');

      // Ask theme sections to bundle (same as product-form does)
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));
      if (sectionsToBundle.length) {
        formData.append('sections', sectionsToBundle.join(','));
        formData.append('sections_url', Shopify.routes.root + 'variants/' + idInput.value);
      }

      fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok) {
          atcBtn.disabled = false;
          atcBtn.textContent = orig;
          return;
        }
        var responseJson = result.json;
        return fetch(Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartContent) {
            cartContent['sections'] = responseJson['sections'];
            // force_open_drawer bypasses cartType:"page" redirect — drawer always opens
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                onSuccessDo: 'force_open_drawer',
                cart: cartContent
              }
            }));
            atcBtn.disabled = false;
            atcBtn.textContent = orig;

            // Reset bar to Step 1 after successful add
            if (selectedSizeBtn) {
              selectedSizeBtn.classList.remove('is-selected');
              selectedSizeBtn = null;
            }
            if (atcBtn)    atcBtn.hidden    = true;
            if (selectBtn) selectBtn.hidden = false;
          });
      })
      .catch(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = orig;
      });
    }

    /* ── Populate size buttons from hidden variant-picker DOM ─ */
    function populateSizeButtons() {
      if (!variantPicker) return;

      var firstFieldset = variantPicker.querySelector('fieldset.variant-picker__option');
      if (!firstFieldset) return;

      // pack-variant-card (product-pack style), block/thumbnail swatch, and combined-product <a> links
      var nativeLabels = firstFieldset.querySelectorAll(
        '.pack-variant-list label.pack-variant-card,' +
        '.variant-picker__option-values label,' +
        '.variant-picker__option-values a'
      );

      nativeLabels.forEach(function (nativeLabel) {
        var isLink = nativeLabel.tagName === 'A';
        var isPackCard = nativeLabel.classList.contains('pack-variant-card');

        // Disabled: check class or the radio input inside
        var radio = nativeLabel.querySelector('input[type="radio"]');
        var isDisabled = nativeLabel.classList.contains('is-disabled') || (radio && radio.disabled);
        if (isDisabled) return;

        // Extract display text
        var text = '';
        if (isPackCard) {
          var titleEl = nativeLabel.querySelector('.pack-variant-card__title');
          text = titleEl ? titleEl.textContent.trim() : '';
        } else if (nativeLabel.classList.contains('thumbnail-swatch')) {
          var el = nativeLabel.querySelector('p.custom-variant-name') || nativeLabel.querySelector('.sr-only');
          text = el ? el.textContent.trim() : '';
        } else {
          var spanEl = nativeLabel.querySelector('span:not(.sr-only):not(.block-swatch__color)');
          text = spanEl ? spanEl.textContent.trim() : nativeLabel.textContent.trim();
        }

        if (!text) return;

        var btn = document.createElement('button');
        btn.type      = 'button';
        btn.className = 'mob-atc-bar__size-btn';
        btn.textContent = text;

        // Mark pre-selected: pack-variant-card (checked radio) or combined product <a>
        var isPreSelected = (isPackCard && radio && radio.checked) ||
                            (isLink && nativeLabel.classList.contains('is-selected'));
        if (isPreSelected) {
          btn.classList.add('is-selected');
          selectedSizeBtn = btn;
        }

        btn.addEventListener('click', function () {
          if (isLink) {
            window.location.href = nativeLabel.href;
            return;
          }
          if (selectedSizeBtn) selectedSizeBtn.classList.remove('is-selected');
          btn.classList.add('is-selected');
          selectedSizeBtn = btn;
          nativeLabel.click();
          closePanel();
          if (selectBtn) selectBtn.hidden = true;
          if (atcBtn)    atcBtn.hidden    = false;
        });

        sizeGrid.appendChild(btn);
      });

      // Sync pre-selected state (show ATC if something already selected)
      syncPreSelected();
    }

    /* ── Sync pre-selected variant (e.g. from URL param) ─── */
    function syncPreSelected() {
      if (!variantPicker) return;

      // Combined products: active option is an <a> with is-selected class
      // populateSizeButtons already marks it — just show ATC if one is marked
      if (selectedSizeBtn) {
        if (selectBtn) selectBtn.hidden = true;
        if (atcBtn)    atcBtn.hidden    = false;
        return;
      }

      // Find checked radio across all variant styles
      var checkedRadio = variantPicker.querySelector(
        '.pack-variant-list input[type="radio"]:checked,' +
        '.variant-picker__option-values input[type="radio"]:checked'
      );
      if (!checkedRadio) return;

      var labelEl = variantPicker.querySelector(
        'label[for="' + CSS.escape(checkedRadio.id) + '"]'
      );
      if (!labelEl) return;

      var nativeText = '';
      if (labelEl.classList.contains('pack-variant-card')) {
        var el2 = labelEl.querySelector('.pack-variant-card__title');
        nativeText = el2 ? el2.textContent.trim() : '';
      } else if (labelEl.classList.contains('thumbnail-swatch')) {
        var el3 = labelEl.querySelector('p.custom-variant-name') || labelEl.querySelector('.sr-only');
        nativeText = el3 ? el3.textContent.trim() : '';
      } else {
        var spanEl2 = labelEl.querySelector('span:not(.sr-only):not(.block-swatch__color)');
        nativeText = spanEl2 ? spanEl2.textContent.trim() : labelEl.textContent.trim();
      }

      sizeGrid.querySelectorAll('.mob-atc-bar__size-btn').forEach(function (mBtn) {
        if (
          mBtn.textContent.trim() === nativeText &&
          !mBtn.classList.contains('is-disabled')
        ) {
          if (selectedSizeBtn) selectedSizeBtn.classList.remove('is-selected');
          mBtn.classList.add('is-selected');
          selectedSizeBtn = mBtn;
          if (selectBtn) selectBtn.hidden = true;
          if (atcBtn)    atcBtn.hidden    = false;
        }
      });
    }
  }

  /* ── Bootstrap ────────────────────────────────────────────── */
  function init() {
    document.querySelectorAll('.mob-atc-bar').forEach(initMobAtcBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
